/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { IpStorageService } from './ip-storage.service';

/**
 * @internal
 */
export default class FreeUsersIpStorage extends IpStorageService {}
